import * as React from "react"
import { connect } from "react-redux"

import { Modal } from "@tenforce/toolbox-modal-react"

import { GlobalState } from "../../../store"
import { DispatchProps, mapDispatchToProps } from "../actions"
import ConceptsTable from "./concepts/ConceptsTable"
import Workspaces from "./workspaces/Workspaces"
import { IConceptsPage } from "../index"

type StateProps = IConceptsPage

type Props = StateProps & DispatchProps

export class ConceptsPage extends React.Component<Props> {
    render(): JSX.Element {
        const { createConceptVisible } = this.props

        return (
            <>
                <ConceptsTable />
                <Modal
                    isShown={createConceptVisible}
                    containerProps={{
                        id: "createConceptModal",
                        targetSelector: "#CreateAction",
                        onClose: this.hideCreateConceptModal,
                    }}
                    contentProps={{
                        extraClasses: "bg-default",
                        isFixed: (): boolean => false,
                    }}
                >
                    <Workspaces />
                </Modal>
            </>
        )
    }

    hideCreateConceptModal = (): void => {
        const { updateCreateConceptVisibility } = this.props
        updateCreateConceptVisibility(false)
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage,
})

export default connect(mapStateToProps, mapDispatchToProps)(ConceptsPage)
